
























import mixins from 'vue-typed-mixins';
import { AutomatedEmailParams } from '@/utils/EmailUtils';
import SurveyUtils, { SurveyGroup, Survey } from '../../../utils/SurveyUtils';
import { DataTableHeader } from 'vuetify';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => AutomatedEmailParams,
    },
  },

  computed: {
    surveyGroupsOptions(): any {
      return this.surveyGroups?.map((surveyGroup) => ({
        text: surveyGroup.name,
        value: surveyGroup,
      }));
    },

    headers(): DataTableHeader<Survey>[] {
      return [
        { text: this.$i18n.tc('model.common.name'), value: 'name.admin' },
      ];
    },
  },

  data(): {
    surveyGroups?: SurveyGroup[];
    surveys?: Survey[];
  } {
    return {
      surveyGroups: undefined,
      surveys: undefined,
    };
  },

  async mounted() {
    try {
      this.$emit('validate', true); // always valid
      this.surveyGroups = await SurveyUtils.api.surveyGroup.list();
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },

  watch: {
    async 'value.surveygroup'() {
      if (this.value?.surveygroup) {
        try {
          this.$alert.hide('surveys');
          this.surveys = undefined;
          this.value.surveys = undefined;
          this.surveys = await SurveyUtils.api.survey.list({
            surveygroupid: this.value?.surveygroup?.id,
          });
        } catch (error) {
          this.$alert.show('surveys', {
            type: 'error',
            messages: this.$handleAPIError(error),
          });
        }
      } else {
        this.surveys = [];
        this.value.surveys = undefined;
      }
    },
  },
});
